import { render } from "./christophBrand.vue?vue&type=template&id=99ddf9d0"
import script from "./christophBrand.vue?vue&type=script&lang=js"
export * from "./christophBrand.vue?vue&type=script&lang=js"

import "./christophBrand.vue?vue&type=style&index=0&id=99ddf9d0&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__